import React, { useEffect, useMemo } from 'react';
import { Row, Col, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { directSupplierFieldNames, directSupplierFormFields, indirectSupplierFieldNames, indirectSupplierFormFields } from './formField';
import { FormField } from 'components';
import { omit } from 'lodash';
import { updateFormField } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { isBeneficiary } from 'utils';
import { useSupplierType } from 'hooks/useSupplierType';

const TermsSupplier = () => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const terms = useSelector(state => state.forms.terms);
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || 
                  !isBeneficiary(user.groups) || 
                  applicationReturned ||
                  activeTaskName === "task.name.temporary_rejected" ||
                  activeTaskName === "task.name.application_returned_to_supplier" ||
                  activeTaskName === "task.name.accepted";

  const fieldNames = useMemo(() =>
    [
      ...(isDirectSupplier ? directSupplierFieldNames : []),
      ...(isIndirectSupplier ? indirectSupplierFieldNames : []),
    ],
  [isDirectSupplier, isIndirectSupplier])

  useEffect(() => {
    const values = fieldNames.reduce((acc, fieldName) => {
      acc[fieldName] = terms[fieldName];
      return acc;
    }, {});
    
    form.setFieldsValue(values);
  }, [fieldNames, form, terms]);

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString("en-US");
    } else if (type === 'select' || type === 'number' || type === 'switch') {
      newValue = event;
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    }

    dispatch(
      updateFormField({
        group: 'terms',
        key,
        value: newValue,
      })
    );
  };

  return (
    <div>
      {/* {!viewMode && requiredFieldsError && (
        <div className="stepper-warning-message error-message">
          <div>
            Για την ενεργοποίηση της υποβολής απαιτείται η συμπλήρωση των
            υποχρεωτικών πεδίων και των δικαιολογητικών.
          </div>
          <Cancel
            className="cancel-icon"
            onClick={() => setRequiredFieldsError(false)}
            />
            </div>
            )} */}
      <Form
        form={form}
        initialValues={
          {
            // ...carrier,
          }
        }
        trigger="onChange"
      >
        {isDirectSupplier && <>
          <p className="mt-3 color-blue-3 text-bold font-size-24">
            Όροι και Προϋποθέσεις άμεσου προμηθευτή
          </p>
          <p className='text-bold'>
            Ο προμηθευτής βεβαιώνει/συναινεί:
          </p>
          <Row style={{ width: '91%' }}>
            {directSupplierFormFields.map((field) => {
              return (
                <Col key={field.id} className="gutter-row" span={24}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    valuePropName="checked"
                  >
                    <FormField
                      disabled={viewMode}
                      style={
                        viewMode
                          ? { pointerEvents: 'none', cursor: 'not-allowed' }
                          : {}
                      }
                      className={viewMode ? 'custom-checkbox-disabled' : ''}
                      {...omit(field, ['span', 'rules'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </>}
        {isIndirectSupplier && <>
          <p className={`mt-3 color-blue-3 text-bold font-size-24`}>
            Όροι και Προϋποθέσεις έμμεσου προμηθευτή
          </p>
          <p className='text-bold'>
            Ο προμηθευτής βεβαιώνει/συναινεί:
          </p>
          <Row style={{ width: '91%' }}>
            {indirectSupplierFormFields.map((field) => {
              return (
                <Col key={field.id} className="gutter-row" span={24}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    valuePropName="checked"
                  >
                    <FormField
                      disabled={viewMode}
                      style={
                        viewMode
                          ? { pointerEvents: 'none', cursor: 'not-allowed' }
                          : {}
                      }
                      className={viewMode ? 'custom-checkbox-disabled' : ''}
                      {...omit(field, ['span', 'rules'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </>}
      </Form>
    </div>
  );
};

export default TermsSupplier;
